import { render, staticRenderFns } from "./StudyNotFound.vue?vue&type=template&id=51e90930&scoped=true"
import script from "./StudyNotFound.vue?vue&type=script&lang=js"
export * from "./StudyNotFound.vue?vue&type=script&lang=js"
import style0 from "./StudyNotFound.vue?vue&type=style&index=0&id=51e90930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e90930",
  null
  
)

export default component.exports